import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

// TODO: format in this file is for backwards compatibility, however, it should likely be updated to more closely match the way the other track* files are written
// note the keys in defaultData below are all passed in through drupal JS currently, for an example, see:
// sites/bobbibrown/themes/bb_base/template_api/loyalty/loyalty_popup_offer_v1/src/loyalty_popup_offer_v1.js

const defaultData: IDataLayer = {
  event_name: 'account_loyalty',
  event_category: 'account_loyalty',
  event_action: null, // depends on source of tag
  event_label: null, // depends on source of tag
  event_noninteraction: null,
};

function trackLoyalty(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('loyaltyTag', trackLoyalty);
